// extracted by mini-css-extract-plugin
export default {"formRow":"formRow__sH0oQ","label":"label__sy4x1","select":"select__eO3t_"};